export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14962.61287435.jpg";